import type { ReactNode } from 'react'

type Variant = 'accent' | 'neutral' | 'warning' | 'danger' | 'info'

const VARIANT_CLASSES: Record<Variant, string> = {
  accent: 'bg-[var(--accent-subtle)] text-[var(--accent-text)]',
  neutral: 'bg-[var(--bg-badge)] text-[var(--text-secondary)]',
  warning: 'bg-[var(--warning-bg)] text-[var(--warning)]',
  danger: 'bg-[var(--danger-bg)] text-[var(--danger)]',
  info: 'bg-[var(--info-bg)] text-[var(--info)]',
}

export function Badge({
  children,
  variant = 'neutral',
  className = '',
}: Readonly<{
  children: ReactNode
  variant?: Variant
  className?: string
}>) {
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold whitespace-nowrap ${VARIANT_CLASSES[variant]} ${className}`}
    >
      {children}
    </span>
  )
}
